import {
    Component,
    ComponentInterface,
    h,
    Prop,
    Event,
    Host,
} from "@stencil/core";
import type { EventEmitter } from "@stencil/core";

@Component({
    tag: "c-form-button",
    styleUrl: "c-form-button.scss",
})
export class CFormButton implements ComponentInterface {
    @Prop() btnName: string;
    @Prop() pageNum: string;
    @Prop() targetRef: string;
    @Prop() germanTitle?: string;
    @Prop() theme?: string;
    @Prop() icon?: string;
    @Prop() stage?: string;
    @Prop() BotId: string;
    @Event() submitInput: EventEmitter<string>;
    @Event() buttonSuggestionSelected: EventEmitter;
    private formLang = localStorage.getItem("FormLang");
    // @ts-ignore
    private message;
    btnIcon = this.icon ? this.icon : "default";

    handleClick() {
        const formElements = document
            .getElementsByTagName("ba-chatbot")
            .item(0)
            ?.shadowRoot?.querySelector("c-dialog")
            ?.shadowRoot?.querySelectorAll("form > *");
        if (!formElements) return;
        let result = "";
        let langRes = "";

        switch (this.BotId) {
            case "FORM": {
                alert("Formular Assistent");
                break;
            }
            case "INKASSO": {
                alert("INKASSO");
                break;
            }
            // default: {
            //     alert("No Form defined");
            //     break;
            // }
        }

        if (this.formLang === "ua") {
            langRes = "";
        }

        // @FutureTask Outsource functions for different elements
        formElements.forEach((element) => {
            if (element.querySelector("input")?.type === "text") {
                result +=
                    element.querySelector("label")?.innerHTML +
                    "=" +
                    element.querySelector("input")?.value +
                    ";";
                if (this.formLang === "ua") {
                    langRes +=
                        element
                            .querySelector("label")
                            ?.getAttribute("data-german") +
                        "=" +
                        element.querySelector("input")?.value +
                        ";";
                }
            } else if (element.querySelector("input")?.type === "date") {
                result +=
                    element.querySelector("label")?.innerHTML +
                    "=" +
                    element.querySelector("input")?.value +
                    ";";
                if (this.formLang === "ua") {
                    langRes +=
                        element
                            .querySelector("label")
                            ?.getAttribute("data-german") +
                        "=" +
                        element.querySelector("input")?.value +
                        ";";
                }
            } else if (
                element.querySelector('input[name="buttonGroup"]:checked')
            ) {
                result +=
                    element.querySelector(".radio-group")?.innerHTML +
                    "=" +
                    (
                        element.querySelector(
                            'input[name="buttonGroup"]:checked'
                        ) as HTMLInputElement
                    ).value +
                    ";";
                if (this.formLang === "ua") {
                    langRes +=
                        element
                            .querySelector(".radio-group")
                            ?.getAttribute("data-german") +
                        "=" +
                        (
                            element.querySelector(
                                'input[name="buttonGroup"]:checked'
                            ) as HTMLInputElement
                        ).getAttribute("data-german") +
                        ";";
                }
            } else if (element.querySelector("select")) {
                const select = element.querySelector("select");
                result +=
                    element.querySelector("label")?.innerHTML +
                    "=" +
                    select?.value +
                    ";";
                if (this.formLang === "ua") {
                    langRes +=
                        element
                            .querySelector("label")
                            ?.getAttribute("data-german") +
                        "=" +
                        select?.selectedOptions
                            .item(0)
                            ?.getAttribute("data-german") +
                        ";";
                }
            } else if (element.querySelector("textarea")) {
                const select = element.querySelector("textarea");
                result +=
                    element.querySelector("label")?.innerHTML +
                    "=" +
                    select?.value;
                if (this.formLang === "ua") {
                    langRes +=
                        element
                            .querySelector("label")
                            ?.getAttribute("data-german") +
                        "=" +
                        select?.value;
                }
            } else return;
        });

        if (localStorage.getItem(this.pageNum)) {
            const lStorage = localStorage.getItem(this.pageNum);
            localStorage.setItem(this.pageNum, lStorage + "||" + result);
        } else {
            localStorage.setItem(this.pageNum, result);
        }

        if (this.formLang === "ua") {
            if (localStorage.getItem("DE_" + this.pageNum)) {
                const lStorage = localStorage.getItem("DE_" + this.pageNum);
                localStorage.setItem(
                    "DE_" + this.pageNum,
                    lStorage + "||" + langRes
                );
            } else {
                localStorage.setItem("DE_" + this.pageNum, langRes);
            }
        }
    }

    render() {
        return (
            <Host>
                <button
                    class={`submit-button ${this.theme ? this.theme : ""}`}
                    type="submit"
                    data-german={this.germanTitle}
                    onClick={this.funcCall.bind(this)}
                >
                    <div
                        class="submit-container"
                        innerHTML={
                            this.btnIcon.includes("left")
                                ? `${this.buttonLabel(this.btnIcon)} ${
                                    this.btnName
                                }`
                                : `${this.btnName} ${this.buttonLabel(
                                    this.btnIcon
                                )}`
                        }
                    ></div>
                </button>
            </Host>
        );
    }

    // @FutureTask Create Object from all variables
    private sendData = async () => {
        if (this.BotId === "FORM") {
            // Benutzte Sprachform

            // Initialization of VARS
            let refugee;
            let addressData;
            let address;
            let street;
            let homeNumber;
            let additionals;
            let postalCode;
            let town;
            let country;
            let personalData;
            let personal;
            let firstname;
            let lastname;
            let birthname;
            let birthdate;
            let gender;
            let nationality;
            let status;
            let children;
            let ageYChild;
            let numChildren;
            let driverLicence;
            let dlClass;
            let contactData;
            let contact;
            let phoneNumber;
            let email;
            let messageContact;
            let visa;
            let visaTill = "-";
            let visaTillFullData;
            let visaTillData;
            let workAllowed = "-";
            let prefJob;
            let schoolDegree;
            let study;
            let studyDegree;
            let apprentenceship;
            let apprentenceType;
            let educationDataFull;
            let educationData;
            let educationsData;
            let languageDataFull;
            let lang;
            let languageData;
            const education = {};
            const language = {};

            if (this.formLang === "de") {
                // Refugee
                refugee = localStorage.getItem("Refugee");

                // Adresse
                addressData = localStorage.getItem("Adresse");
                if (addressData) {
                    address = addressData.split(";");
                    if (address) {
                        street = address[0].split("=")[1];
                        homeNumber = address[1].split("=")[1];
                        additionals = address[2].split("=")[1] || "-";
                        postalCode = address[3].split("=")[1];
                        town = address[4].split("=")[1];
                        country = address[5].split("=")[1];
                    }
                }

                // Persönliche Daten
                personalData = localStorage.getItem("PersonalData");
                if (personalData) {
                    personal = personalData.split(";");
                    if (personal) {
                        firstname = personal[0].split("=")[1];
                        lastname = personal[1].split("=")[1];
                        birthname = personal[2].split("=")[1];
                        birthdate = personal[3]
                            .split("=")[1]
                            .split("-")
                            .reverse()
                            .join(".");
                        gender = personal[4].split("=")[1];
                        nationality = personal[5].split("=")[1];
                    }
                }
                status = localStorage.getItem("Status");
                children = localStorage.getItem("Kinder");
                ageYChild =
                    children === "Ja"
                        ? localStorage
                            .getItem("Geburtstag_J_Kind")!
                            .split(";")[0]
                            .split("=")[1]
                            .split("-")
                            .reverse()
                            .join(".")
                        : "-";
                numChildren =
                    children === "Ja" ? localStorage.getItem("Kinderanzahl") : "-";
                driverLicence = localStorage.getItem("Führerschein");
                dlClass =
                    driverLicence === "Ja"
                        ? localStorage
                            .getItem("Führerscheinklasse")!
                            .split(";")[0]
                            .split("=")[1]
                        : "-";

                // Kontaktdaten
                contactData = localStorage.getItem("Kontaktdaten");
                if (contactData) {
                    contact = contactData.split(";");
                    if (contact) {
                        phoneNumber = contact[0].split("=")[1];
                        email = contact[1].split("=")[1];
                        messageContact = contact[2].split("=")[1];
                    }
                }

                // Visum & Erwerbstätigkeit
                visa =
                    localStorage.getItem("Visumangabe") === "Sonstige"
                        ? localStorage.getItem("Aufenthaltstitel")!.split("=")[1]
                        : localStorage.getItem("Visumangabe")!;
                if (visa !== "Ich weiß es nicht") {
                    visaTillFullData = localStorage.getItem("Gültigkeitsdatum");
                    if (visaTillFullData) {
                        visaTillData = visaTillFullData.split(";");
                        if (visaTillData[0].split("=")[1] === "") {
                            visaTill = visaTillData[1].split("=")[1];
                        } else {
                            visaTill = visaTillData[0]
                                .split("=")[1]
                                .split("-")
                                .reverse()
                                .join(".");
                        }
                    }
                    workAllowed =
                        localStorage.getItem("Arbeitserlaubnis") === "Sonstige"
                            ? localStorage
                                .getItem("Erwerbstätigkeitstitel")!
                                .split("=")[1]
                            : localStorage.getItem("Arbeitserlaubnis")!;
                }

                // Wunschjob
                prefJob = localStorage.getItem("WunschJob");
                if (prefJob) prefJob = prefJob.split("=")[1];

                // Jobs, Ausbildung und Schule
                schoolDegree = localStorage.getItem("Schulabschluss");
                study = localStorage.getItem("Studienabschluss");
                studyDegree = !study!.includes("kein")
                    ? localStorage
                        .getItem("Studienfach")!
                        .split(";")[0]
                        .split("=")[1]
                    : "-";
                apprentenceship = localStorage.getItem("Ausbildung");
                apprentenceType = !apprentenceship!.includes("kein")
                    ? localStorage
                        .getItem("Berufsausbildung")!
                        .split(";")[0]
                        .split("=")[1]
                    : "-";
                educationDataFull = localStorage.getItem("Education");
                if (educationDataFull) {
                    educationData = educationDataFull.split("||");
                    if (educationData) {
                        educationData.map((educations, index) => {
                            educationsData = educations.split(";");
                            education[index] = {
                                start: educationsData[1]
                                    .split("=")[1]
                                    .split("-")
                                    .reverse()
                                    .join(".")
                                    .slice(3),
                                end: educationsData[2]
                                    .split("=")[1]
                                    .split("-")
                                    .reverse()
                                    .join(".")
                                    .slice(3),
                                type: educationsData[0].split("=")[1],
                                name: educationsData[4].split("=")[1],
                                location: educationsData[3].split("=")[1],
                                degree: educationsData[5].split("=")[1],
                            };
                        });
                    }
                }

                // Sprachkenntnisse
                languageDataFull = localStorage.getItem("Language");
                if (languageDataFull) {
                    languageData = languageDataFull.split("||");
                    if (languageData) {
                        languageData.map((languages, index) => {
                            lang = languages.split(";");
                            language[index] = {
                                name: lang[0].split("=")[1],
                                level: lang[1].split("=")[1],
                            };
                        });
                    }
                }

                this.message = {
                    german: {
                        refugee,
                        address: {
                            street,
                            number: homeNumber,
                            additionals,
                            postal_code: postalCode,
                            town,
                            country,
                        },
                        personal: {
                            firstname,
                            lastname,
                            birthname,
                            birthdate,
                            gender,
                            nationality,
                            status,
                            children,
                            age_y_child: ageYChild,
                            num_children: numChildren,
                            driver_licence: driverLicence,
                            dl_class: dlClass,
                            phone_number: phoneNumber,
                            email,
                            message: messageContact,
                            visa,
                            visa_till: visaTill,
                            work_allowed: workAllowed,
                            school_degree: schoolDegree,
                            study,
                            study_degree: studyDegree,
                            apprentenceship,
                            apprentence_type: apprentenceType,
                            pref_job: prefJob,
                            education,
                            language,
                        },
                    },
                };
            } else {
                // DE
                // Refugee
                refugee = localStorage.getItem("DE_Refugee");

                // Adresse
                addressData = localStorage.getItem("DE_Adresse");
                if (addressData) {
                    address = addressData.split(";");
                    if (address) {
                        street = address[0].split("=")[1];
                        homeNumber = address[1].split("=")[1];
                        additionals = address[2].split("=")[1] || "-";
                        postalCode = address[3].split("=")[1];
                        town = address[4].split("=")[1];
                        country = address[5].split("=")[1];
                    }
                }

                // Persönliche Daten
                personalData = localStorage.getItem("DE_PersonalData");
                if (personalData) {
                    personal = personalData.split(";");
                    if (personal) {
                        firstname = personal[0].split("=")[1];
                        lastname = personal[1].split("=")[1];
                        birthname = personal[2].split("=")[1];
                        birthdate = personal[3]
                            .split("=")[1]
                            .split("-")
                            .reverse()
                            .join(".");
                        gender = personal[4].split("=")[1];
                        nationality = personal[5].split("=")[1];
                    }
                }
                status = localStorage.getItem("DE_Status");
                children = localStorage.getItem("DE_Kinder");
                ageYChild =
                    children === "Ja"
                        ? localStorage
                            .getItem("DE_Geburtstag_J_Kind")!
                            .split(";")[0]
                            .split("=")[1]
                            .split("-")
                            .reverse()
                            .join(".")
                        : "-";
                numChildren =
                    children === "Ja" ? localStorage.getItem("Kinderanzahl") : "-";
                driverLicence = localStorage.getItem("DE_Führerschein");
                dlClass =
                    driverLicence === "Ja"
                        ? localStorage
                            .getItem("DE_Führerscheinklasse")!
                            .split(";")[0]
                            ?.split("=")[1]
                        : "-";

                // Kontaktdaten
                contactData = localStorage.getItem("DE_Kontaktdaten");
                if (contactData) {
                    contact = contactData.split(";");
                    if (contact) {
                        phoneNumber = contact[0].split("=")[1];
                        email = contact[1].split("=")[1];
                        messageContact = contact[2].split("=")[1];
                    }
                }

                // Visum & Erwerbstätigkeit
                visa =
                    localStorage.getItem("DE_Visumangabe") === "Sonstige"
                        ? localStorage.getItem("DE_Aufenthaltstitel")!.split("=")[1]
                        : localStorage.getItem("DE_Visumangabe")!;
                if (visa !== "Ich weiß es nicht") {
                    visaTillFullData = localStorage.getItem("DE_Gültigkeitsdatum");
                    if (visaTillFullData) {
                        visaTillData = visaTillFullData.split(";");
                        if (visaTillData[0].split("=")[1] === "") {
                            visaTill = visaTillData[1].split("=")[1];
                        } else {
                            visaTill = visaTillData[0]
                                .split("=")[1]
                                .split("-")
                                .reverse()
                                .join(".");
                        }
                    }
                    workAllowed =
                        localStorage.getItem("DE_Arbeitserlaubnis") === "Sonstige"
                            ? localStorage
                                .getItem("DE_Erwerbstätigkeitstitel")!
                                .split("=")[1]
                            : localStorage.getItem("DE_Arbeitserlaubnis")!;
                }

                // Wunschjob
                prefJob = localStorage.getItem("DE_WunschJob");
                if (prefJob) prefJob = prefJob.split("=")[1];

                // Jobs, Ausbildung und Schule
                schoolDegree = localStorage.getItem("DE_Schulabschluss");
                study = localStorage.getItem("DE_Studienabschluss");
                studyDegree = !study!.includes("kein")
                    ? localStorage
                        .getItem("DE_Studienfach")!
                        .split(";")[0]
                        .split("=")[1]
                    : "-";
                apprentenceship = localStorage.getItem("DE_Ausbildung");
                apprentenceType = !apprentenceship!.includes("kein")
                    ? localStorage
                        .getItem("DE_Berufsausbildung")!
                        .split(";")[0]
                        .split("=")[1]
                    : "-";
                educationDataFull = localStorage.getItem("DE_Education");
                if (educationDataFull) {
                    educationData = educationDataFull.split("||");
                    if (educationData) {
                        educationData.map((educations, index) => {
                            educationsData = educations.split(";");
                            education[index] = {
                                start: educationsData[1]
                                    .split("=")[1]
                                    .split("-")
                                    .reverse()
                                    .join(".")
                                    .slice(3),
                                end: educationsData[2]
                                    .split("=")[1]
                                    .split("-")
                                    .reverse()
                                    .join(".")
                                    .slice(3),
                                type: educationsData[0].split("=")[1],
                                name: educationsData[4].split("=")[1],
                                location: educationsData[3].split("=")[1],
                                degree: educationsData[5].split("=")[1],
                            };
                        });
                    }
                }

                // Sprachkenntnisse
                languageDataFull = localStorage.getItem("DE_Language");
                if (languageDataFull) {
                    languageData = languageDataFull.split("||");
                    if (languageData) {
                        languageData.map((languages, index) => {
                            lang = languages.split(";");
                            language[index] = {
                                name: lang[0].split("=")[1],
                                level: lang[1].split("=")[1],
                            };
                        });
                    }
                }

                // UA
                // Refugee
                const uarefugee = localStorage.getItem("Refugee");

                // Adresse
                const uaaddressData = localStorage.getItem("Adresse");
                let uastreet;
                let uahomeNumber;
                let uaadditionals;
                let uapostalCode;
                let uatown;
                let uacountry;
                if (uaaddressData) {
                    const uaaddress = uaaddressData.split(";");
                    if (uaaddress) {
                        uastreet = uaaddress[0].split("=")[1];
                        uahomeNumber = uaaddress[1].split("=")[1];
                        uaadditionals = uaaddress[2].split("=")[1] || "-";
                        uapostalCode = uaaddress[3].split("=")[1];
                        uatown = uaaddress[4].split("=")[1];
                        uacountry = uaaddress[5].split("=")[1];
                    }
                }

                // Persönliche Daten
                const uapersonalData = localStorage.getItem("PersonalData");
                let uafirstname;
                let ualastname;
                let uabirthname;
                let uabirthdate;
                let uagender;
                let uanationality;
                if (uapersonalData) {
                    const uapersonal = uapersonalData.split(";");
                    if (uapersonal) {
                        uafirstname = uapersonal[0].split("=")[1];
                        ualastname = uapersonal[1].split("=")[1];
                        uabirthname = uapersonal[2].split("=")[1];
                        uabirthdate = uapersonal[3]
                            .split("=")[1]
                            .split("-")
                            .reverse()
                            .join(".");
                        uagender = uapersonal[4].split("=")[1];
                        uanationality = uapersonal[5].split("=")[1];
                    }
                }
                const uastatus = localStorage.getItem("Status");
                const uachildren = localStorage.getItem("Kinder");
                const uaageYChild =
                    uachildren === "так"
                        ? localStorage
                            .getItem("Geburtstag_J_Kind")!
                            .split(";")[0]
                            .split("=")[1]
                            .split("-")
                            .join(".")
                        : "-";
                const uanumChildren =
                    uachildren === "так"
                        ? localStorage.getItem("Kinderanzahl")
                        : "-";
                const uadriverLicence = localStorage.getItem("Führerschein");
                const uadlClass =
                    uadriverLicence === "так"
                        ? localStorage
                            .getItem("Führerscheinklasse")!
                            .split(";")[0]
                            .split("=")[1]
                        : "-";

                // Kontaktdaten
                const uacontactData = localStorage.getItem("Kontaktdaten");
                let uaphoneNumber;
                let uaemail;
                let uamessageContact;
                if (uacontactData) {
                    const uacontact = uacontactData.split(";");
                    if (uacontact) {
                        uaphoneNumber = uacontact[0].split("=")[1];
                        uaemail = uacontact[1].split("=")[1];
                        uamessageContact = uacontact[2].split("=")[1];
                    }
                }

                // Visum & Erwerbstätigkeit
                let uavisaTill = "-";
                let uaworkAllowed = "-";
                const uavisa =
                    localStorage.getItem("Visumangabe") === "Інше"
                        ? localStorage.getItem("Aufenthaltstitel")!.split("=")[1]
                        : localStorage.getItem("Visumangabe");
                if (uavisa !== "Я не знаю") {
                    const uavisaTillFullData =
                        localStorage.getItem("Gültigkeitsdatum");
                    if (uavisaTillFullData) {
                        const uavisaTillData = uavisaTillFullData.split(";");
                        if (uavisaTillData[0].split("=")[1] === "") {
                            uavisaTill = uavisaTillData[1].split("=")[1];
                        } else {
                            uavisaTill = uavisaTillData[0]
                                .split("=")[1]
                                .split("-")
                                .reverse()
                                .join(".");
                        }
                    }
                    uaworkAllowed =
                        localStorage.getItem("Arbeitserlaubnis") === "Інше"
                            ? localStorage
                                .getItem("Erwerbstätigkeitstitel")!
                                .split("=")[1]
                            : localStorage.getItem("Arbeitserlaubnis")!;
                }

                // Wunschjob
                let uaprefJob = localStorage.getItem("WunschJob");
                if (uaprefJob) uaprefJob = uaprefJob.split("=")[1];

                // Jobs, Ausbildung und Schule
                const uaschoolDegree = localStorage.getItem("Schulabschluss");
                const uastudy = localStorage.getItem("Studienabschluss");
                const uastudyDegree = !uastudy!.includes("немає")
                    ? localStorage
                        .getItem("Studienfach")!
                        .split(";")[0]
                        .split("=")[1]
                    : "-";
                const uaapprentenceship = localStorage.getItem("Ausbildung");
                const uaapprentenceType = !uaapprentenceship!.includes("немає")
                    ? localStorage
                        .getItem("Berufsausbildung")!
                        .split(";")[0]
                        .split("=")[1]
                    : "-";
                const uaeducationDataFull = localStorage.getItem("Education");
                const uaeducation = {};
                if (uaeducationDataFull) {
                    const uaeducationData = uaeducationDataFull.split("||");
                    if (uaeducationData) {
                        uaeducationData.map((uaeducations, index) => {
                            const uaeducationsData = uaeducations.split(";");
                            uaeducation[index] = {
                                start: uaeducationsData[1]
                                    .split("=")[1]
                                    .split("-")
                                    .reverse()
                                    .join(".")
                                    .slice(3),
                                end: uaeducationsData[2]
                                    .split("=")[1]
                                    .split("-")
                                    .reverse()
                                    .join(".")
                                    .slice(3),
                                type: uaeducationsData[0].split("=")[1],
                                name: uaeducationsData[4].split("=")[1],
                                location: uaeducationsData[3].split("=")[1],
                                degree: uaeducationsData[5].split("=")[1],
                            };
                        });
                    }
                }

                // Sprachkenntnisse
                const ualanguageDataFull = localStorage.getItem("Language");
                const ualanguage = {};
                let ualang;
                if (ualanguageDataFull) {
                    const ualanguageData = ualanguageDataFull.split("||");
                    if (ualanguageData) {
                        ualanguageData.map((ualanguages, index) => {
                            ualang = ualanguages.split(";");
                            ualanguage[index] = {
                                name: ualang[0].split("=")[1],
                                level: ualang[1].split("=")[1],
                            };
                        });
                    }
                }

                this.message = {
                    german: {
                        refugee,
                        address: {
                            street,
                            number: homeNumber,
                            additionals,
                            postal_code: postalCode,
                            town,
                            country,
                        },
                        personal: {
                            firstname,
                            lastname,
                            birthname,
                            birthdate,
                            gender,
                            nationality,
                            status,
                            children,
                            age_y_child: ageYChild,
                            num_children: numChildren,
                            driver_licence: driverLicence,
                            dl_class: dlClass,
                            phone_number: phoneNumber,
                            email,
                            message: messageContact,
                            visa,
                            visa_till: visaTill,
                            work_allowed: workAllowed,
                            school_degree: schoolDegree,
                            study,
                            study_degree: studyDegree,
                            apprentenceship,
                            apprentence_type: apprentenceType,
                            pref_job: prefJob,
                            education,
                            language,
                        },
                    },
                    ukraine: {
                        refugee: uarefugee,
                        address: {
                            street: uastreet,
                            number: uahomeNumber,
                            additionals: uaadditionals,
                            postal_code: uapostalCode,
                            town: uatown,
                            country: uacountry,
                        },
                        personal: {
                            firstname: uafirstname,
                            lastname: ualastname,
                            birthname: uabirthname,
                            birthdate: uabirthdate,
                            gender: uagender,
                            nationality: uanationality,
                            status: uastatus,
                            children: uachildren,
                            age_y_child: uaageYChild,
                            num_children: uanumChildren,
                            driver_licence: uadriverLicence,
                            dl_class: uadlClass,
                            phone_number: uaphoneNumber,
                            email: uaemail,
                            message: uamessageContact,
                            visa: uavisa,
                            visa_till: uavisaTill,
                            work_allowed: uaworkAllowed,
                            school_degree: uaschoolDegree,
                            study: uastudy,
                            study_degree: uastudyDegree,
                            apprentenceship: uaapprentenceship,
                            apprentence_type: uaapprentenceType,
                            pref_job: uaprefJob,
                            education: uaeducation,
                            language: ualanguage,
                        },
                    },
                };
            }
        } else {
            const formEnd = localStorage.getItem("FormularAbschluss");
            if (formEnd) {
                const gender = formEnd.split(";")[0].split("=")[1];
                const firstname = formEnd.split(";")[1].split("=")[1];
                const lastname = formEnd.split(";")[2].split("=")[1];
                const vnumber = formEnd.split(";")[3].split("=")[1];
                const phone = formEnd.split(";")[4].split("=")[1];
                const mail = formEnd.split(";")[5].split("=")[1];
                const message = formEnd.split(";")[6].split("=")[1].split("||")[0];


                const email = {
                    gender,
                    firstname,
                    lastname,
                    vnumber,
                    phone,
                    mail,
                    message,
                }
                alert(`Email Object Data -` + JSON.stringify(email))
            }
        }
    }

    private changeLang(lang: string) {
        const bot = document.getElementsByTagName("ba-chatbot")[0];
        bot.setAttribute("page-id", "form/form-" + lang);
    }

    private buttonLabel = (icon: string) => {
        switch (icon.toLowerCase()) {
            case "icon-right": {
                return `<svg
                            version="1.0"
                            id="Ebene_1"
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            fill="currentColor"
                            viewBox="0 0 18 18"
                            class="arrow"
                        >
                            <path
                                d="M2,9c0-0.3,0.2-0.5,0.5-0.5h11.8l-3.1-3.1c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l4,4c0.2,0.2,0.2,0.5,0,0.7
	                              c0,0,0,0,0,0l-4,4c-0.2,0.2-0.5,0.2-0.7,0s-0.2-0.5,0-0.7l3.1-3.1H2.5C2.2,9.5,2,9.3,2,9z"
                            />
                        </svg>`;
            }
            case "icon-left": {
                return `<svg
                        version="1.0"
                        id="Ebene_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        fill="currentColor"
                        viewBox="0 0 18 18"
                    >
                        <path
                            d="M14.5,3.1c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1l-7.8,9.8c-0.6,0.6-1.5,0.6-2.1,0.1c0,0,0,0,0,0L1.4,9.8
	                              c-0.6-0.6-0.6-1.5,0-2.1s1.5-0.6,2.1,0l4.1,4.1L14.5,3.1C14.5,3.1,14.5,3.1,14.5,3.1L14.5,3.1z"
                        />
                    </svg>`;
            }
            case "icon-left-x": {
                return `<svg
                        version="1.0"
                        id="Ebene_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        fill="currentColor"
                        viewBox="0 0 18 18"
                    >
                        <path
                            d="M2.3,2.3c0.4-0.4,1-0.4,1.4,0L9,7.6l5.3-5.3c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4c0,0,0,0,0,0L10.4,9l5.3,5.3
                            	  c0.4,0.4,0.4,1,0,1.4c-0.4,0.4-1,0.4-1.4,0L9,10.4l-5.3,5.3c-0.4,0.4-1,0.4-1.4,0c-0.4-0.4-0.4-1,0-1.4L7.6,9L2.3,3.7
                            	  C1.9,3.3,1.9,2.7,2.3,2.3z"
                        />
                    </svg>`;
            }
            case "icon-left-p": {
                return `<svg
                        version="1.0"
                        id="Ebene_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        fill="currentColor"
                        viewBox="0 0 18 18"
                    >
                        <path
                            d="M9,1c0.6,0,1,0.4,1,1v6h6c0.6,0,1,0.4,1,1c0,0.6-0.4,1-1,1h-6v6c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1v-6H2c-0.6,0-1-0.4-1-1
	                              c0-0.6,0.4-1,1-1h6V2C8,1.4,8.4,1,9,1z"
                        />
                    </svg>`;
            }
            default: {
                return;
            }
        }
    };

    private funcCall = () => {
        this.handleClick();

        if (this.stage) localStorage.setItem("FormState", this.stage);

        if (this.pageNum === "StartFormular" && this.formLang) {
            this.changeLang(this.formLang);
            if (this.formLang === "ua") {
                localStorage.setItem("StartFormular", "FormularUA");
                localStorage.setItem("StartFormular_DE", "FormularDE");
            } else {
                localStorage.setItem("StartFormular", "FormularDE");
            }
        }

        if (this.pageNum === "FormularAbschluss") {
            // console.log(this.message)
            this.sendData();
            localStorage.clear();
        }

        this.buttonSuggestionSelected.emit({
            title: this.btnName,
            payload: this.targetRef,
        });
    };
}
